export const getSubUrlName = (location: { pathname: string }): string => {
  const splitPathName: string[] = location.pathname.split('/');
  return splitPathName[1] || "";
};

export const getUrlToken = ()  => {
  return new URLSearchParams(window.location.search).get("token");
};

export const getUrlParameter = (param: string, decode?: boolean)  => {
  const value =  new URLSearchParams(window.location.search).get(param);
  return decode ? decodeURIComponent(value ?? '') : value
};

export const mainUrl = 'https://www.sunbit.com';
